<template>
  <nav v-if="$store.getters.isAuthenticated" data-cy="main-nav">
    <template v-for="link of navLinks">
      <hr
        v-if="link.divideBefore"
        :key="`divider-${link.e2eLabel}`"
        class="nav-divider"
        role="separator"
      />
      <NavigationItem
        :key="link.e2eLabel"
        :link-data="link"
        @closeMenu="$emit('closeMenu')"
      />
    </template>
  </nav>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import NavigationItem from './NavigationItem.vue'
import navLinks from './nav-links'

@Component({
  components: {
    NavigationItem
  }
})
export default class NavigationMenu extends Vue {
  navLinks = navLinks()
}
</script>

<style lang="scss" scoped>
nav {
  position: fixed;
  top: $logo-container-height;
  left: 0;
  bottom: 0;
  width: min(290px, 85vw);
  max-width: 290px;
  background: $dark-blue;
  box-shadow: 0 -1px 0 0 $dark-blue;
  z-index: 100;
  transform: translateX(-100%);
  transition: transform 222ms ease-in-out;
  overflow-y: auto;

  &.opened {
    transform: translateX(0);
  }
}

.nav-divider {
  border: 0;
  // Nearest role token. The DS has no inverse hairline border; this is a
  // separator on the dark nav panel, not a state overlay. BP-5 owns the real fix.
  border-top: 1px solid $color-overlay-medium;
  margin: 8px 15px 4px;
}
</style>
